import {
  SET_ALL_ORGANIZATION_PROFILE,
  SELECT_ORGANIZATION_PROFILE,
  REMOVE_ORGANIZATION_PROFILE,
  UPDATE_ORGANIZATION_PROFILE,
  ADD_ORGANIZATION_PROFILE,
  SET_ORGANIZATION_PROFILES,
  SET_ORGANIZATION_ID,
  SET_ORGANIZATION_METRICS_BY_ID,
  SET_INFINITE_ORGANIZATIONS,
  SET_SEARCHED_ORGANIZATIONS,
  SET_MANAGED_ORGANIZATIONS,
  SET_SEARCHED_MANAGED_ORGANIZATIONS,
  RESET_STATE,
  SET_RISK_PROFILE,
  SET_LIST_OF_STEPS,
  SET_QUESTIONS_LIST_BY_STEP_ID,
  SET_QUESTION_BY_ID,
  GET_ORGA_DESCRIPTION,
  GET_XML_DATA,
} from "../types/organizationProfileType";

const initialState = {
  all: [],
  question: {},
  selected: null,
  webApp: false,
  organizationProfiles: [],
  id: null,
  tabsCompleted: null,
  totalPages: 0,
  organizationMetricsById: {},
  infinteOrganizations: [],
  managedOrganizations: [],
  completedQuizzes: null,
  completedThreatQuizzes: null,
  orgaUser: {},
  embedToken: null,
  embedUrl: null,
  reportId: null,
  reportName: null,
  filteredPages: [],
  startPage: {},
  completedThreatQuizzesNumber: null,
  listOfSteps: [],
  listOfQuestionsByStepId: [],
  orga_description: "",
  xml_data: {},
  xml_data_orga_id: null,
};

const organizationProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORGA_DESCRIPTION:
      return { ...state, orga_description: action.payload };
    case SET_ALL_ORGANIZATION_PROFILE:
      return { ...state, all: action.payload };
    case SELECT_ORGANIZATION_PROFILE:
      return {
        ...state,
        selected: action.payload.orga,
        webApp: action.payload.webApp,
        tabsCompleted: 5,
        completedQuizzes: action.payload.completedQuizzes,
        completedThreatQuizzes: action.payload.completedThreatQuizzes,
        orgaUser: action.payload.orgaUser,
        completedThreatQuizzesNumber:
          action.payload.completedThreatQuizzesNumber,
      };
    case SET_RISK_PROFILE:
      return {
        ...state,
        embedToken: action.payload.embedToken,
        embedUrl: action.payload.embedUrl,
        reportId: action.payload.reportId,
        reportName: action.payload.reportName,
        filteredPages: action.payload.filteredPages,
        startPage: action.payload.startPage,
      };
    case SET_INFINITE_ORGANIZATIONS:
      return {
        ...state,
        infinteOrganizations: [
          ...state.infinteOrganizations,
          ...action.payload.profiles,
        ],
        totalPages: action.payload.totalPages,
      };
    case SET_SEARCHED_ORGANIZATIONS:
      return {
        ...state,
        infinteOrganizations: action.payload.profiles,
        totalPages: action.payload.totalPages,
      };
    case SET_MANAGED_ORGANIZATIONS:
      return {
        ...state,
        managedOrganizations: [
          ...state.managedOrganizations,
          ...action.payload.profiles,
        ],
        totalPages: action.payload.totalPages,
      };
    case SET_SEARCHED_MANAGED_ORGANIZATIONS:
      return {
        ...state,
        managedOrganizations: action.payload.profiles,
        totalPages: action.payload.totalPages,
      };
    case SET_ORGANIZATION_METRICS_BY_ID:
      return {
        ...state,
        organizationMetricsById: action.payload,
      };
    case REMOVE_ORGANIZATION_PROFILE:
      return {
        ...state,
        all: state.organizationProfiles.filter(
          (item) => item.id !== action.payload
        ),
        infinteOrganizations: state.infinteOrganizations.filter(
          (item) => item.id !== action.payload
        ),
        managedOrganizations: state.managedOrganizations.filter(
          (item) => item.id !== action.payload
        ),
      };
    case UPDATE_ORGANIZATION_PROFILE:
      return {
        ...state,
        all: state.all.map((item) =>
          item._id === action.payload.id
            ? { ...item, ...action.payload.data }
            : item
        ),
      };
    case ADD_ORGANIZATION_PROFILE:
      return { ...state, all: [...state.all, action.payload] };
    case SET_ORGANIZATION_PROFILES:
      return {
        ...state,
        organizationProfiles: action.payload.profiles,
        totalPages: action.payload.totalPages,
      };
    case SET_ORGANIZATION_ID:
      return { ...state, id: action.payload };
    case SET_LIST_OF_STEPS:
      return { ...state, listOfSteps: action.payload };
    case SET_QUESTIONS_LIST_BY_STEP_ID:
      return { ...state, listOfQuestionsByStepId: action.payload };
    case SET_QUESTION_BY_ID:
      return { ...state, question: action.payload };
    case RESET_STATE:
      return initialState;
    case GET_XML_DATA:
      // The owner is stored with the data so a reader can tell whose profile it
      // is holding. A component that cannot answer that question renders
      // whatever happens to be there, which across a tenant boundary is a leak
      // rather than a stale view.
      return {
        ...state,
        xml_data: action.payload,
        xml_data_orga_id: action.orgaId ?? null,
      };
    default:
      return state;
  }
};

export default organizationProfileReducer;
